












import Vue from 'vue'
import loadingMixin from '@/mixin/loadingMixin'
import XCircularProgress from '@/components/atoms/CircularProgress/XCircularProgress.vue'
import XOverlay from '@/components/atoms/Overlay/XOverlay.vue'
import { LayoutType, layouts } from '@/components/templates'

export default Vue.extend({
  name: 'App',
  mixins: [loadingMixin],
  components: {
    ...layouts,
    XCircularProgress,
    XOverlay,
  },
  computed: {
    layout(): LayoutType {
      return this.$route.meta.layout || 'default'
    },
  },
})
